import { useQuery } from 'react-query';
import { OptionExerciseService } from '@wealthlane/api-services/wealthlane-award-service';
import { convertNumberWithCommas } from '../../utils/global';

const useGetOptionExerciseTaxDetail = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string,
  setInitialValue?: any
) => {
  const optionExerciseTaxDetail = useQuery(
    ['getOptionExerciseTaxDetail', id],
    async () => {
      if (id) {
        return await handleRequest(
          OptionExerciseService.getApiAwardApiAppOptionExerciseTaxDetailsByTransactionId(id)
        );
      }
    },
    {
      onSuccess: (response: any) => {
        if (response != null && setInitialValue) {
          const formattedTaxDetails = {
            ...response,
            taxDetails: response?.taxDetails?.map((taxDetail: any) => ({
              ...taxDetail,
              taxRate: convertNumberWithCommas(Number(taxDetail.taxRate).toFixed(4), true),
              taxAmount: convertNumberWithCommas(Number(taxDetail.taxAmount).toFixed(4), true),
            })),
          };

          setInitialValue(formattedTaxDetails);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
  return optionExerciseTaxDetail;
};

export default useGetOptionExerciseTaxDetail;
